import AddIcon from "@mui/icons-material/Add";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import { Box, Button, Card, IconButton, Typography } from "@mui/material";
import moment from "moment";
import { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../../../../../components/CustomButton";
import CustomModal from "../../../../../components/CustomModal/CustomModal";
import CustomTextField from "../../../../../components/CustomTextField";
import {
  createPrescriptionWoLoader,
  deletePrescriptionItemByIdWoLoader,
  getPetsCompliantSummaryWoLoader,
  updatePrescriptionByIdWoLoader,
} from "../../../../../redux/reducers/petSlice";
import { AppColors } from "../../../../../util/AppColors";
import { frequncyCheckList } from "../../../../../util/arrayList";
import { formatPetWeight } from "../../../../../util/clinicMeasurementUnits";
import { a4PrintConfig } from "../../../../../util/commonConfig";
import { routeList } from "../../../../../util/dropList";
import { frequencyConEnum, genderEnum } from "../../../../../util/enum";
import { printFromNode, warmPrintFrame } from "../../../../../util/fastPrint";
import { getRightSaluation } from "../../../../../util/function";
import { canWriteModule } from "../../../../../util/roleModuleAccess";
import ContentToPrint from "../../../../CommonScreens/ContentToPrint/ContentToPrint";
import PrescriptionView from "../../../../CommonScreens/WorkBook/PrescriptionView";
import AddPrescriptionDrawer from "./AddPrescriptionDrawer";
import EditPrescriptionDrawer from "./EditPrescriptionDrawer";
import PrescriptionCard from "./PrescriptionCard";

const addIcon = { color: AppColors.appPrimary, width: 15, height: 15 };

const prescriptionPrintConfig = `${a4PrintConfig}
@media print {
  .pet-procedures-prescription-print.prescription-print-root p,
  .pet-procedures-prescription-print.prescription-print-root .MuiTypography-root {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
    line-height: 1.25 !important;
  }
}`;

const PrescriptionSection = () => {
  const dispatch = useDispatch();
  const canManageDashboard = canWriteModule("dashboard");
  const contentToPrint = useRef(null);
  const [isExpanded, setIsExpanded] = useState(true);
  const [isAddDrawerOpen, setIsAddDrawerOpen] = useState(false);
  const [isEditDrawerOpen, setIsEditDrawerOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [delModVsble, setDelModVsble] = useState(false);
  const [deleteDetailId, setDeleteDetailId] = useState(null);
  const [presNotesVisible, setPresNotesVisible] = useState(false);
  const [notes, setNotes] = useState("");
  const [isNotesEdit, setIsNotesEdit] = useState(false);
  const [isSavingNotes, setIsSavingNotes] = useState(false);
  const [previewModVsble, setPreviewModVsble] = useState(false);
  const [vetSignUrl, setVetSignUrl] = useState(null);

  const reqDet = useSelector((state) => state?.pet?.complaintSummary?.data);
  const appDet = reqDet?.appointment;
  const mandateDataRaw = sessionStorage.getItem("mandateData");
  const { clinicDet, clinicVets, clinicStocks } = useMemo(() => {
    if (!mandateDataRaw) {
      return { clinicDet: {}, clinicVets: [], clinicStocks: [] };
    }
    try {
      const reqData = JSON.parse(mandateDataRaw);
      return {
        clinicDet: reqData?.clinic ?? {},
        clinicVets: Array.isArray(reqData?.vets) ? reqData.vets : [],
        clinicStocks: Array.isArray(reqData?.stocks) ? reqData.stocks : [],
      };
    } catch {
      return { clinicDet: {}, clinicVets: [], clinicStocks: [] };
    }
  }, [mandateDataRaw]);

  useEffect(() => {
    const remark = reqDet?.prescription?.[0]?.remark ?? "";
    if (remark?.length > 0) {
      setPresNotesVisible(true);
      setNotes(remark);
      setIsNotesEdit(false);
    } else if (!isNotesEdit) {
      setNotes("");
    }
  }, [
    reqDet?.prescription?.[0]?.remark,
    reqDet?.prescription?.[0]?.prescriptionId,
  ]);

  const onApiCall = () => {
    if (appDet?.appointmentId) {
      dispatch(getPetsCompliantSummaryWoLoader(appDet?.appointmentId));
    }
  };

  const buildExistingPresPayload = (li) => {
    const selStock = clinicStocks?.find((stc) => stc?.stockId === li?.stockId);
    const clinicBatches = selStock?.stockBatch?.filter(
      (btch) => btch?.createdBy === clinicDet?.id && btch?.approved,
    );
    const btchDet =
      (li?.batchId
        ? clinicBatches?.find((bat) => bat?.batchId === li?.batchId)
        : null) ?? clinicBatches?.[0];
    const reqFreqList = Array.isArray(li?.frequencyDuration)
      ? li.frequencyDuration
      : [];
    const reqQty = Number(li?.quantity ?? 1) || 1;
    const taxPercent =
      (btchDet?.cgst ? Number(btchDet?.cgst) : 0) +
      (btchDet?.sgst ? Number(btchDet?.sgst) : 0);
    const reqPercent = 100 + Number(taxPercent);
    const unitSellingPrice = btchDet?.unitSellingPrice
      ? Number(btchDet?.unitSellingPrice)
      : Number(li?.price ?? li?.mrpPrice ?? 0);
    const unitPrice = unitSellingPrice / (reqPercent / 100);
    const taxValue = Number(unitSellingPrice - Number(unitPrice)) ?? 0;

    const reqObj = {
      administered: false,
      type: li?.type ?? null,
      stockId: li?.stockId,
      batchId: btchDet?.batchId ?? li?.batchId ?? null,
      name: li?.name,
      dosage: li?.dosage ?? "",
      duration: li?.duration ?? "1",
      route: li?.route ?? null,
      meal: li?.meal ?? "",
      quantity: reqQty,
      subUnit: "Unit",
      morning: reqFreqList?.includes("morning") ?? false,
      afternoon: reqFreqList?.includes("afternoon") ?? false,
      night: reqFreqList?.includes("night") ?? false,
      adminChargeAmount: 0,
      adminCharge: "N",
      percentage: false,
      delete: false,
      discontinued: "N",
      detailId: li?.id ?? li?.detailId ?? null,
      remark: li?.remark ?? "",
      drugSchedule: selStock?.drugSchedule ?? null,
      hsnSacCode: selStock?.hsnSacCode ?? li?.hsnSacCode ?? null,
      packageUom: btchDet?.salesUom ?? li?.packageUom ?? null,
      expiryDate: btchDet?.expiryDate ?? li?.expiryDate ?? null,
      batchNo: btchDet?.batchNo ?? li?.batchNo ?? null,
      shortName: selStock?.shortName ?? null,
      price: unitSellingPrice,
      mrpPrice: unitSellingPrice,
      mrpDiscount: 0,
      tax: Number(taxValue) * reqQty,
      total: unitSellingPrice * Number(reqQty),
      frequencyDuration: reqFreqList ?? [],
    };
    if (li?.productId) reqObj.productId = li?.productId;
    if (li?.serviceId) reqObj.serviceId = li?.serviceId;
    return reqObj;
  };

  const handleSaveNotes = () => {
    const existingDetails = [
      ...(reqDet?.prescription?.[0]?.prescriptionDetails ?? []),
    ].sort((a, b) => {
      const ai = Number(a?.id ?? a?.detailId);
      const bi = Number(b?.id ?? b?.detailId);
      return (Number.isFinite(ai) ? ai : 0) - (Number.isFinite(bi) ? bi : 0);
    });
    const prescription = existingDetails.map(buildExistingPresPayload);
    const data = {
      status: "Pending",
      remark: notes ?? "",
      prescription,
      issue: "",
      paymentId: reqDet?.paymentId ?? null,
    };

    setIsSavingNotes(true);
    const onSuccess = () => {
      setIsSavingNotes(false);
      setIsNotesEdit(false);
      onApiCall();
    };
    const onFail = () => setIsSavingNotes(false);

    if (reqDet?.prescription?.[0]?.prescriptionId) {
      dispatch(
        updatePrescriptionByIdWoLoader({
          prescriptionId: reqDet?.prescription?.[0]?.prescriptionId,
          data,
        }),
      ).then((res) => {
        if (res?.payload) onSuccess();
        else onFail();
      });
    } else {
      if (!appDet?.appointmentId) {
        onFail();
        return;
      }
      dispatch(
        createPrescriptionWoLoader({
          appointmentId: appDet?.appointmentId,
          data,
        }),
      ).then((res) => {
        if (res?.payload) onSuccess();
        else onFail();
      });
    }
  };

  const vetSignature =
    clinicVets?.find((vl) => vl?.doctorId === appDet?.doctorId)?.signature ??
    appDet?.signature ??
    null;

  useEffect(() => {
    let cancelled = false;
    const fetchSignature = async () => {
      if (!vetSignature) {
        setVetSignUrl(null);
        return;
      }
      try {
        const res = await fetch(vetSignature, { method: "GET", headers: {} });
        const blob = await res.blob();
        const reader = new FileReader();
        reader.onloadend = () => {
          if (!cancelled) setVetSignUrl(reader.result);
        };
        reader.onerror = () => {
          if (!cancelled) setVetSignUrl(vetSignature);
        };
        reader.readAsDataURL(blob);
      } catch {
        if (!cancelled) setVetSignUrl(vetSignature);
      }
    };
    fetchSignature();
    return () => {
      cancelled = true;
    };
  }, [vetSignature]);

  useEffect(() => {
    if (!previewModVsble || typeof window === "undefined") return;
    let cancelled = false;
    const warm = () => {
      if (cancelled) return;
      const node = contentToPrint.current;
      if (node) warmPrintFrame(node, prescriptionPrintConfig);
    };
    const frameId = requestAnimationFrame(warm);
    const node = contentToPrint.current;
    const imgs = node ? [...node.querySelectorAll("img")] : [];
    imgs.forEach((img) => {
      if (!img.complete) {
        img.addEventListener("load", warm, { once: true });
        img.addEventListener("error", warm, { once: true });
      }
    });
    return () => {
      cancelled = true;
      cancelAnimationFrame(frameId);
      imgs.forEach((img) => {
        img.removeEventListener("load", warm);
        img.removeEventListener("error", warm);
      });
    };
  }, [previewModVsble, clinicDet?.image, vetSignUrl]);

  const handleOpenAddDrawer = () => {
    setIsAddDrawerOpen(true);
  };

  const handleOpenEditDrawer = (item) => {
    setSelectedItem(item);
    setIsEditDrawerOpen(true);
  };

  const onCloseDelMod = () => {
    setDelModVsble(false);
    setDeleteDetailId(null);
  };

  const handleDeleteItem = (detailId) => {
    if (!detailId) return;
    setDeleteDetailId(detailId);
    setDelModVsble(true);
  };

  const onConfirmDelete = () => {
    if (!deleteDetailId) return;
    dispatch(deletePrescriptionItemByIdWoLoader(deleteDetailId)).then((res) => {
      if (res?.payload) {
        onCloseDelMod();
        if (appDet?.appointmentId) {
          dispatch(getPetsCompliantSummaryWoLoader(appDet?.appointmentId));
        }
      }
    });
  };

  const getPrescriptionList = () => {
    const prescDetails = reqDet?.prescription?.[0]?.prescriptionDetails;
    const reqPresDetList = [
      ...(Array.isArray(prescDetails) ? prescDetails : []),
    ]?.sort((a, b) => {
      const ai = Number(a?.id);
      const bi = Number(b?.id);
      return (Number.isFinite(ai) ? ai : 0) - (Number.isFinite(bi) ? bi : 0);
    });

    return reqPresDetList?.map((li, i) => {
      const reqObj = {
        ...li,
        detailId: li?.id,
        name: null,
        dosage: li?.dosage,
        duration: li?.duration,
        meal: li?.meal,
        plName: li?.name,
        i,
        type: li?.type,
        stockId: li?.stockId,
        qty: li?.quantity,
        isEdit: false,
        route: routeList?.find((rl) => rl?.name === li?.route) ?? null,
        remark: li?.remark ?? "",
        frequency: [],
      };
      if (
        Array.isArray(li?.frequencyDuration) &&
        li.frequencyDuration.length > 0
      ) {
        reqObj.frequency = li.frequencyDuration
          .map((freq) => frequncyCheckList?.find((f) => f?.apiValue === freq))
          ?.filter(Boolean);
      }
      return reqObj;
    });
  };

  const normalizePresDetailForPrint = (li, i = 0) => {
    const frequencyDuration =
      Array.isArray(li?.frequencyDuration) && li.frequencyDuration.length > 0
        ? li.frequencyDuration
        : Array.isArray(li?.frequency)
          ? li.frequency
              .map(
                (fre) =>
                  fre?.apiValue ??
                  frequencyConEnum[fre?.value ?? fre] ??
                  (typeof fre === "string" ? fre : null),
              )
              .filter(Boolean)
          : [];
    const route =
      typeof li?.route === "object"
        ? (li?.route?.name ?? li?.route?.value ?? "")
        : (li?.route ?? "");
    return {
      ...li,
      id: li?.id ?? li?.detailId ?? i,
      detailId: li?.detailId ?? null,
      name: li?.name ?? li?.plName ?? "",
      plName: li?.plName ?? li?.name ?? "",
      shortName: li?.shortName ?? "",
      dosage: li?.dosage ?? "",
      duration: li?.duration ?? "1",
      route,
      meal: li?.meal ?? "",
      remark: li?.remark ?? "",
      frequencyDuration,
      morning: li?.morning ?? false,
      afternoon: li?.afternoon ?? false,
      night: li?.night ?? false,
    };
  };

  const getReqPresList = () => {
    if (reqDet?.prescription?.length > 0) {
      return (reqDet.prescription ?? []).map((pres) => ({
        ...pres,
        remark: notes || pres?.remark || "",
        prescriptionDetails: (pres?.prescriptionDetails ?? []).map(
          normalizePresDetailForPrint,
        ),
      }));
    }
    return [];
  };

  const handlePrint = () => {
    printFromNode(contentToPrint.current, {
      title: "",
      pageStyle: prescriptionPrintConfig,
    });
  };

  const prescriptions = getPrescriptionList();
  const showPreview = prescriptions.length > 0 || presNotesVisible;

  return (
    <Box sx={{ width: "100%", mt: 2, mb: 4 }}>
      <Card
        sx={{
          borderRadius: "8px",
          boxShadow: "0px 1px 4px rgba(0, 0, 0, 0.08)",
          border: "1px solid #e0e0e0",
          backgroundColor: "#ffffff",
          overflow: "hidden",
        }}
      >
        <Box
          onClick={() => setIsExpanded(!isExpanded)}
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            px: 2.5,
            py: 1.8,
            cursor: "pointer",
            backgroundColor: "#ffffff",
            userSelect: "none",
            "&:hover": {
              backgroundColor: "#fafafa",
            },
          }}
        >
          <Typography
            sx={{
              fontWeight: 700,
              color: AppColors.appPrimary,
              fontSize: "16px",
            }}
          >
            Prescription{" "}
            <span
              style={{
                fontSize: "13px",
                fontWeight: 400,
                color: "#757575",
                marginRight: "4px",
              }}
            >
              (take-home)
            </span>{" "}
            ({prescriptions.length})
          </Typography>

          <IconButton size="small" sx={{ color: AppColors.appPrimary }}>
            {isExpanded ? <ArrowDropDownIcon /> : <ArrowRightIcon />}
          </IconButton>
        </Box>

        {isExpanded && (
          <Box px={2.5} pb={2.5} pt={1}>
            <Box mb={2}>
              {prescriptions.map((item) => (
                <PrescriptionCard
                  key={item.detailId ?? item.i}
                  item={item}
                  onEdit={handleOpenEditDrawer}
                  onDelete={handleDeleteItem}
                />
              ))}
              {prescriptions.length === 0 && (
                <Typography sx={{ fontSize: "14px", color: "#9e9e9e", py: 2 }}>
                  No take-home medications prescribed yet.
                </Typography>
              )}
            </Box>

            {presNotesVisible ? (
              <Box mb={2}>
                <CustomTextField
                  fullWidth
                  value={notes ?? ""}
                  handleChange={(e) => {
                    setNotes(e?.target?.value);
                    setIsNotesEdit(true);
                  }}
                  multiline
                  placeholder="Notes"
                  expandWithContent
                  disabled={!isNotesEdit}
                />
              </Box>
            ) : null}

            {canManageDashboard ? (
              <Box
                onClick={handleOpenAddDrawer}
                sx={{
                  border: "1.5px dashed #90caf9",
                  borderRadius: "8px",
                  backgroundColor: "#f8faff",
                  py: 1.5,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  transition: "all 0.2s ease-in-out",
                  "&:hover": {
                    backgroundColor: "#eef4ff",
                    borderColor: AppColors.appPrimary,
                  },
                }}
              >
                <Button
                  startIcon={<AddIcon sx={{ fontSize: 20 }} />}
                  sx={{
                    color: AppColors.appPrimary,
                    fontWeight: 700,
                    fontSize: "14px",
                    textTransform: "none",
                    pointerEvents: "none",
                  }}
                >
                  Add medication
                </Button>
              </Box>
            ) : null}

            <Box
              display="flex"
              alignItems="center"
              mt={2}
              className="flex-row-ali-cen"
            >
              {canManageDashboard ? (
                <Box
                  display="flex"
                  alignItems="center"
                  className="flex-row-ali-cen cursor"
                  onClick={() => {
                    setPresNotesVisible(true);
                    setIsNotesEdit(true);
                  }}
                  sx={{ cursor: "pointer" }}
                >
                  <Box className="flex-center plus-icon">
                    <AddIcon sx={addIcon} />
                  </Box>
                  <Typography className="blue-color fs16 ml5 font-bold">
                    Add Notes
                  </Typography>
                </Box>
              ) : null}

              {isNotesEdit ? (
                <Box ml={2.5}>
                  <CustomButton
                    text="Save"
                    smallBtn
                    disabled={isSavingNotes}
                    onClick={handleSaveNotes}
                  />
                </Box>
              ) : null}

              {showPreview ? (
                <Box ml={canManageDashboard || isNotesEdit ? 2.5 : 0}>
                  <CustomButton
                    text="Preview"
                    smallBtn
                    onClick={() => setPreviewModVsble(true)}
                  />
                </Box>
              ) : null}
            </Box>
          </Box>
        )}
      </Card>

      <AddPrescriptionDrawer
        open={isAddDrawerOpen}
        onClose={() => setIsAddDrawerOpen(false)}
      />

      <EditPrescriptionDrawer
        open={isEditDrawerOpen}
        onClose={() => setIsEditDrawerOpen(false)}
        item={selectedItem}
      />

      <CustomModal
        open={delModVsble}
        onClose={onCloseDelMod}
        header=""
        modal
        modalWidth={30}
        headerShown={false}
      >
        <div className="flex-center">
          <Typography className="txt-semi-bold fs16 text-align-center mv20 orange4">
            Are you sure you want to delete this record?
          </Typography>
        </div>
        <div className="flex-row-ali-cen flex-center pb20">
          <div>
            <CustomButton
              text="Yes"
              redBtn
              smallBtn
              onClick={onConfirmDelete}
            />
          </div>
          <div className="ml20">
            <CustomButton text="No" smallBtn onClick={onCloseDelMod} />
          </div>
        </div>
      </CustomModal>

      <CustomModal
        open={previewModVsble}
        onClose={() => setPreviewModVsble(false)}
        header=""
        headerCenter
        modal
        headerBold
        modalWidth={80}
      >
        <div className="scroll-80vh">
          <ContentToPrint
            ref={contentToPrint}
            rootClassName="pet-procedures-prescription-print"
            footer={
              <div className="prescription-print-footer-inner">
                <div className="mb20 flex-start prescription-print-footer-doctor-row">
                  <div>
                    {vetSignUrl ? (
                      <img
                        src={vetSignUrl}
                        alt=""
                        className="h40 prescription-print-vet-signature"
                      />
                    ) : null}
                    <div className="txt-semi-bold fs12 black">
                      Clinician Signature
                    </div>
                  </div>
                </div>
                {appDet?.appointmentType === "Virtual" ? (
                  <div className="flex-center prescription-print-footer-disclaimer">
                    <div className="flex-row-ali-cen">
                      <div className="font-bold fs12 black">
                        Telemedicine Disclaimer:
                      </div>
                      <div className="txt-regular fs12 black ml10">
                        This prescription has been generated through
                        telemedicine consultation.
                      </div>
                    </div>
                  </div>
                ) : null}
                {clinicDet?.footer?.length > 0 ? (
                  <img src={clinicDet?.footer} alt="" />
                ) : null}
              </div>
            }
            header={
              <div className="flex-row-ali-cen mv20">
                <div className="w35Per">
                  <div>
                    {clinicDet?.image ? (
                      <img src={clinicDet?.image} className="img-h75" alt="" />
                    ) : (
                      <div className="flex-center h50img">
                        <Typography className="font-bold fs30 white-color capitalize">
                          {clinicDet?.name?.[0]}
                        </Typography>
                      </div>
                    )}
                  </div>
                </div>
                <div className="w30Per flex-center">
                  <div className="font-bold fs20 blue-color">Prescription</div>
                </div>
                <div className="w35Per flex1-end">
                  <div className="prescription-doc-header-clinic">
                    <div className="font-bold blue-color fs16">
                      {clinicDet?.name ?? ""}
                    </div>
                    <div className="txt-regular fs12 blue-color">
                      {clinicDet?.address ?? ""}
                    </div>
                    {clinicDet?.taxId?.length > 0 ? (
                      <div className="flex-row-ali-cen mt5">
                        <div className="font-bold fs12 blue-color">
                          TAX ID:{" "}
                        </div>
                        <div className="txt-regular fs12 blue-color ml3">
                          {clinicDet?.taxId ?? ""}
                        </div>
                      </div>
                    ) : null}
                    {clinicDet?.mobile?.length > 0 ? (
                      <div className="flex-row-ali-cen mt5">
                        <div className="font-bold fs12 blue-color">
                          Contact:{" "}
                        </div>
                        <div className="txt-regular fs12 blue-color ml3">
                          {clinicDet?.mobile ?? ""}
                        </div>
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            }
          >
            <tr>
              <td className="prescription-print-tbody-cell">
                <div className="prescription-print-body-inner">
                  <div className="p5">
                    <div>
                      <div className="flex-row prescription-print-patient-block">
                        <div className="w65Per">
                          <div className="flex-column">
                            <div className="flex-row mv2">
                              {appDet?.petType?.length > 0 ? (
                                <>
                                  <div className="font-bold fs12 blue-color">
                                    Pet Name:
                                  </div>
                                  <div className="font-bold fs12 black capitalize ml5">
                                    {appDet?.petName}
                                  </div>
                                </>
                              ) : null}
                              {appDet?.petType?.length > 0 ? (
                                <>
                                  <div className="font-bold fs12 blue-color ml15">
                                    Species:
                                  </div>
                                  <div className="txt-regular fs12 black capitalize ml5">
                                    {appDet?.petType}
                                  </div>
                                </>
                              ) : null}
                              {appDet?.breed?.length > 0 ? (
                                <>
                                  <div className="font-bold fs12 blue-color ml15">
                                    Breed:
                                  </div>
                                  <div className="txt-regular fs12 black capitalize ml5">
                                    {appDet?.breed}
                                  </div>
                                </>
                              ) : null}
                            </div>
                            <div className="flex-row mv2">
                              {genderEnum?.[appDet?.gender]?.length > 0 ? (
                                <>
                                  <div className="font-bold fs12 blue-color">
                                    Gender:
                                  </div>
                                  <div className="txt-regular fs12 black capitalize ml5">
                                    {genderEnum?.[appDet?.gender]}
                                  </div>
                                </>
                              ) : null}
                              {appDet?.weight?.length > 0 ? (
                                <>
                                  <div className="font-bold fs12 blue-color ml15">
                                    Weight:
                                  </div>
                                  <div className="txt-regular fs12 black capitalize ml5">
                                    {formatPetWeight(appDet?.weight)}
                                  </div>
                                </>
                              ) : null}
                              {appDet?.dob?.length > 0 ? (
                                <>
                                  <div className="font-bold fs12 blue-color ml15">
                                    Age:
                                  </div>
                                  <div className="txt-regular fs12 black capitalize ml5">
                                    {moment(new Date(appDet?.dob))?.fromNow(
                                      true,
                                    )}
                                  </div>
                                </>
                              ) : null}
                            </div>
                            <div className="flex-row mv2">
                              <div className="font-bold fs12 blue-color">
                                Customer:
                              </div>
                              <div className="font-bold fs12 black capitalize ml5">
                                {appDet?.userName}
                              </div>
                            </div>
                            {appDet?.address?.length > 0 ? (
                              <div className="flex-row mv2">
                                <div className="w40Per">
                                  <div className="font-bold fs12 blue-color">
                                    Address:
                                  </div>
                                  <div className="txt-regular fs12 black capitalize ml5">
                                    {appDet?.address}
                                  </div>
                                </div>
                              </div>
                            ) : null}
                          </div>
                        </div>
                        <div className="w35Per">
                          <div className="flex-column">
                            <div className="flex-row mv2">
                              <div className="font-bold fs12 blue-color">
                                Vet Name:
                              </div>
                              <div className="font-bold fs12 black ml5 capitalize">
                                {`${getRightSaluation(clinicVets, appDet?.doctorId)}${
                                  appDet?.doctorName ?? ""
                                }`}
                              </div>
                            </div>
                            {appDet?.registrationNo?.length > 0 ? (
                              <div className="flex-row mv2">
                                <div className="font-bold fs12 blue-color">
                                  RegNo:
                                </div>
                                <div className="font-regular fs12 black ml5 capitalize">
                                  {appDet?.registrationNo}
                                </div>
                              </div>
                            ) : null}
                            <div className="flex-row mv2">
                              <div className="font-bold fs12 blue-color">
                                Date:
                              </div>
                              <div className="txt-regular fs12 black ml5">
                                {moment(
                                  new Date(appDet?.appointmentDate),
                                ).format("DD MMM YYYY")}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="box-hor-split mv10" />
                      <div className="w100Per" style={{ width: "100%" }}>
                        <PrescriptionView
                          prescriptions={getReqPresList()}
                          showShortName={true}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </ContentToPrint>
          <div className="flex1-end mv20">
            <div>
              <CustomButton text="Print" onClick={handlePrint} smallBtn />
            </div>
          </div>
        </div>
      </CustomModal>
    </Box>
  );
};

export default PrescriptionSection;
